import { render, staticRenderFns } from "./OneChatList.vue?vue&type=template&id=12beef9a&"
import script from "./OneChatList.vue?vue&type=script&lang=js&"
export * from "./OneChatList.vue?vue&type=script&lang=js&"
import style0 from "./OneChatList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports